import gql from 'graphql-tag';

export const WindDirectionFragments = {
  id: gql`
    fragment WindDirectionId on WindDirection {
      id
    }
  `,
};
